import { DAVYS_GREY_700, PRIMARY_800 } from "../../colors";
import FlexBox from "../../FlexBox";
import { Body1, Body2, H2 } from "../../Headings";
import SecureIcon from "../../../../assets/secure.svg";
import PersonalIcon from "../../../../assets/personal.svg";
import AccuracyIcon from "../../../../assets/accuracy.svg";
import { IconsContainer, Divider } from "../styles";

const IntroStep = () => (
  <FlexBox column rowGap="2.5rem">
    <FlexBox column rowGap="1.5rem">
      <H2 bold textAlign="center" color={PRIMARY_800}>
        Welcome to Amaha AI! Your Clinical Assistant.
      </H2>
      <Body1 textAlign="center">
        Amaha AI is here to make your work easier and more efficient—so you can
        focus on what truly matters: helping your clients heal. Equipped with
        intelligent tools, Amaha AI helps you summarise key information, ask
        questions about clients and sessions, and keep track of client progress,
        while always maintaining your control and confidentiality.
      </Body1>
    </FlexBox>
    <IconsContainer>
      <FlexBox columnGap="0.5rem" align="center" padding=" 0 0 0 1rem">
        <img src={SecureIcon} alt="Secure" width="32" height="32" />
        <Body1> Secure</Body1>
      </FlexBox>

      <Divider />

      <FlexBox columnGap="0.5rem" align="center">
        <img src={PersonalIcon} alt="Personal" width="32" height="32" />
        <Body1> Personal</Body1>
      </FlexBox>

      <Divider />

      <FlexBox columnGap="0.5rem" align="center" padding="0 1rem 0 0">
        <img src={AccuracyIcon} alt="Accurate" width="32" height="32" />
        <Body1> Accurate</Body1>
      </FlexBox>
    </IconsContainer>
    <Body2 color={DAVYS_GREY_700} textAlign="center">
      Click ‘Next’ to learn more about what Amaha AI can do.{" "}
    </Body2>
  </FlexBox>
);

export default IntroStep;
